var _a, _b, _c, _d;
import { __decorate, __metadata } from "tslib";
import { Module, VuexModule, Action, Mutation } from 'vuex-module-decorators';
import { Actions, Mutations } from '@/store/enums/hrgs/TravelokaTransaction';
import ApiService from '@/core/services/ApiService';
import { swalAlertError } from '@/core/helpers/sweet-alert';
const API_URL = `${process.env.VUE_APP_BASE_URL_DIGITAL}/${process.env.VUE_APP_GENERAL_LOG_WEBAPI}`;
const API_URLS = {
    url: `${API_URL}/api/integrationlog`
};
let TravelokaTransactionModule = class TravelokaTransactionModule extends VuexModule {
    constructor() {
        super(...arguments);
        this.travelokaTransactionList = [];
        this.loading = false;
        this.pagination = {
            totalPage: 0,
            totalPageSize: 0,
            startPaginationIndex: 0,
            endPaginationIndex: 0,
            currentPage: 1
        };
    }
    // *GETTERS
    get getTravelokaTransactionList() {
        return this.travelokaTransactionList;
    }
    // *MUTATIONS
    [_a = Mutations.SET_TRAVELOKA_TRANSACTION_LIST](data) {
        this.travelokaTransactionList = data;
    }
    [_b = Mutations.SET_TRAVELOKA_TRANSACTION_LIST_LOADING](data) {
        this.loading = data;
    }
    [_c = Mutations.SET_TRAVELOKA_TRANSACTION_LIST_PAGINATION](data) {
        const totalPage = data.totalItems || 0;
        const totalPageSize = data.pageSize || this.pagination.totalPageSize;
        const currentPage = data.currentPage || this.pagination.currentPage;
        this.pagination = {
            totalPage,
            totalPageSize,
            currentPage,
            startPaginationIndex: 0,
            endPaginationIndex: Math.floor(totalPage / totalPageSize)
        };
    }
    // *start: ACTION
    [_d = Actions.GET_LIST](payload) {
        const params = {
            ver: 'v1'
        };
        const formdata = payload.data;
        this.context.commit(Mutations.SET_TRAVELOKA_TRANSACTION_LIST_LOADING, true);
        return new Promise((resolve, reject) => {
            ApiService.post(`${API_URLS.url}?${new URLSearchParams(params).toString()}`, formdata)
                .then((response) => {
                const resData = response.data.result.content;
                this.context.commit(Mutations.SET_TRAVELOKA_TRANSACTION_LIST, resData.data);
                // this.context.commit(Mutations.SET_TRAVELOKA_TRANSACTION_LIST_PAGINATION, {
                //   currentPage: payload.data.pageNo,
                //   pageSize: payload.data.pageSize
                // })
                resolve(resData.data);
            })
                .catch((_response) => {
                swalAlertError('Failed show traveloka transaction.', 'Close');
                reject(_response);
            })
                .finally(() => {
                this.context.commit(Mutations.SET_TRAVELOKA_TRANSACTION_LIST_LOADING, false);
            });
        });
    }
};
__decorate([
    Mutation,
    __metadata("design:type", Function),
    __metadata("design:paramtypes", [Array]),
    __metadata("design:returntype", void 0)
], TravelokaTransactionModule.prototype, _a, null);
__decorate([
    Mutation,
    __metadata("design:type", Function),
    __metadata("design:paramtypes", [Object]),
    __metadata("design:returntype", void 0)
], TravelokaTransactionModule.prototype, _b, null);
__decorate([
    Mutation,
    __metadata("design:type", Function),
    __metadata("design:paramtypes", [Object]),
    __metadata("design:returntype", void 0)
], TravelokaTransactionModule.prototype, _c, null);
__decorate([
    Action({ rawError: true }),
    __metadata("design:type", Function),
    __metadata("design:paramtypes", [Object]),
    __metadata("design:returntype", void 0)
], TravelokaTransactionModule.prototype, _d, null);
TravelokaTransactionModule = __decorate([
    Module
], TravelokaTransactionModule);
export default TravelokaTransactionModule;
